const { default: Styled } = require('styled-components');

module.exports = Styled.div`
    height: 40px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
`;
